import { memo } from 'react';
import 'media/css/starRating.scss';

/** Size include small | default */
const StarRating = memo(function StarRatingComponent({ num, size = 'medium' }: { num: number; size?: string }) {
  num = Math.floor(num);

  switch (num) {
    case 1:
      return (
        <div className={`star_wrap ${size}`}>
          <span className="star checked"></span>
          <span className="star"></span>
          <span className="star"></span>
          <span className="star"></span>
          <span className="star"></span>
        </div>
      );
    case 2:
      return (
        <div className={`star_wrap ${size}`}>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star"></span>
          <span className="star"></span>
          <span className="star"></span>
        </div>
      );
    case 3:
      return (
        <div className={`star_wrap ${size}`}>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star"></span>
          <span className="star"></span>
        </div>
      );
    case 4:
      return (
        <div className={`star_wrap ${size}`}>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star"></span>
        </div>
      );
    case 5:
      return (
        <div className={`star_wrap ${size}`}>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
          <span className="star checked"></span>
        </div>
      );
  }
});

export default StarRating;

